<template>
  <div class="footer"  style="  background-color: #ffffff; ">
    <footer-nav></footer-nav>
  </div>
</template>

<script>
  import FooterNav from "../../components/shared/navFooter";

  export default {
    name: "src-pages-footer-shared-v2_white",
    components: {FooterNav},
    data() {
      return {

      }
    },

    methods: {
    }
  }
</script>

<style>
  .footer{
    background: #ffffff;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    padding: 30px 150px;
  }

  .footer ul{
    list-style-type:none;
  }

  .footer li, .footer p{
    display:inline-block;
    font-size: 12px;
    color: #868a8a;
  }

  .footer li:after{
    content:'•';
    padding:0 7px;
  }

  .footer li:last-child:after{
    content:'';
  }
</style>
